import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const ResendTaskAPI = async (
  resendTaskName,
  data,
  t,
  dispatch,
  setOpenResendDialog
) => {
  await axios({
    url: `/api/v2/command/${resendTaskName}`,
    method: "POST",
    data
  });
  let successfulText = `resendTask.${resendTaskName}`;
  successHandling(t, successfulText);
  dispatch({ type: "stopLoading" });
  setOpenResendDialog(false);
  return true;
};
